document.addEventListener("calpak:ready", () => {
  const pricingFilters = document.querySelectorAll(
    ".filter__collection__price"
  );
  pricingFilters.forEach(function (filter) {
    filter.addEventListener("click", function () {
      var price = this.getAttribute("data-price");
      var type = this.getAttribute("data-type");

      const filteredContainers = document.querySelectorAll(
        ".shopify-section--product-grid:has(.enabled-filtering)"
      );

      var active = false;

      if (this.classList.contains("active-pricing")) {
        this.classList.remove("active-pricing");
      } else {
        const activePricing = document.querySelector(
          ".filter__collection__price.active-pricing"
        );
        if (activePricing) activePricing.classList.remove("active-pricing");
        this.classList.add("active-pricing");
        active = true;
      }


      filteredContainers.forEach((container) => {
        let filtered = false;
        const units = container.querySelectorAll(".product-unit");
        units.forEach((unit) => {
          unit.classList.remove("filtered-out-pricing");
          unit
            .querySelectorAll(".color-swatch.slide")
            .forEach(function (swatch) {
              swatch.classList.remove("filtered-out-pricing");
              if(!active) return;
              let isValidSwatch = false;
              if (type == "down") {
                if (
                  parseInt(swatch.getAttribute("data-price")) <=
                  parseInt(price) * 100
                ) {
                  isValidSwatch = true;
                }
              } else {
                if (
                  parseInt(swatch.getAttribute("data-price")) >=
                  parseInt(price) * 100
                ) {
                  isValidSwatch = true;
                }
              }
              if (!isValidSwatch) swatch.classList.add("filtered-out-pricing");
            });
          if (
            unit.querySelector(".color-swatch.slide") &&
            unit.querySelectorAll(
              ".color-swatch.slide:not(.filtered-out-pricing)"
            ).length == 0
          ) {
            filtered = true;
            unit.classList.add("filtered-out-pricing");
          }
        });
        if (filtered) container.classList.add("section-filtered-pricing");
        else container.classList.remove("section-filtered-pricing");
      });
    });
  });
});
